import { createStyle } from '@gluestack-style/react';

export const Center = createStyle({
  alignItems: 'center',
  justifyContent: 'center',
});
